import {
  FiDollarSign,
  FiChevronDown,
  FiSettings,
  FiUser,
  FiFileText,
  FiUsers,
  FiMessageSquare,
  FiHelpCircle,
  FiSpeaker,
  FiSmartphone,
  FiPhoneCall,
  FiLock,
  FiTarget,
} from "react-icons/fi";

import { FiLogOut } from "react-icons/fi";

import {
  Button,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Tooltip,
  useColorModeValue,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuthStore } from "stores/authStore";
import { FaHireAHelper } from "react-icons/fa";

export const UserMenu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuthStore();
  const { user } = useAuthStore();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const menuItemHoverBg = useColorModeValue("gray.100", "whiteAlpha.200");

  return (
    <Menu>
      <Tooltip label={t("common.user.menu.title")} placement="bottom" hasArrow>
        <MenuButton
          as={Button}
          rightIcon={<FiChevronDown />}
          leftIcon={<FiUser />}
          variant="ghost"
        ></MenuButton>
      </Tooltip>
      <MenuList>
        {user && user.isAdmin && (
          <MenuItem
            icon={<FiLock />}
            onClick={() => navigate("/admin")}
            bg={
              location.pathname.includes("/admin") ? menuItemHoverBg : undefined
            }
            _hover={{ bg: menuItemHoverBg }}
          >
            ADMIN
          </MenuItem>
        )}
        <MenuItem
          icon={<FiUser />}
          onClick={() => navigate("/profile")}
          bg={
            location.pathname.includes("/profile") ? menuItemHoverBg : undefined
          }
          _hover={{ bg: menuItemHoverBg }}
        >
          {t("common.user.menu.profile")}
        </MenuItem>
        <MenuItem
          icon={<FiDollarSign />}
          onClick={() => navigate("/payments")}
          bg={
            location.pathname.includes("/payments")
              ? menuItemHoverBg
              : undefined
          }
          _hover={{ bg: menuItemHoverBg }}
        >
          {t("common.user.menu.payments")}
        </MenuItem>
        <MenuItem
          icon={<FiFileText />}
          onClick={() => navigate("/usage")}
          bg={
            location.pathname.includes("/usage") ? menuItemHoverBg : undefined
          }
          _hover={{ bg: menuItemHoverBg }}
        >
          {t("common.user.menu.usage")}
        </MenuItem>
        <MenuItem
          icon={<FiUsers />}
          onClick={() => navigate("/affiliate")}
          bg={
            location.pathname.includes("/affiliate")
              ? menuItemHoverBg
              : undefined
          }
          _hover={{ bg: menuItemHoverBg }}
        >
          {t("common.user.menu.affiliate")}
        </MenuItem>
        <MenuDivider />
        <MenuItem
          icon={<FiSettings />}
          onClick={() => navigate("/settings")}
          bg={
            location.pathname.includes("/settings")
              ? menuItemHoverBg
              : undefined
          }
          _hover={{ bg: menuItemHoverBg }}
        >
          {t("common.user.menu.settings")}
        </MenuItem>
        <MenuItem
          icon={<FiTarget />}
          onClick={() => navigate("/features")}
          bg={
            location.pathname.includes("/features")
              ? menuItemHoverBg
              : undefined
          }
          _hover={{ bg: menuItemHoverBg }}
        >
          {t("common.user.menu.features")}
        </MenuItem>
        <MenuItem
          icon={<FiPhoneCall />}
          onClick={() => navigate("/support")}
          bg={
            location.pathname.includes("/support") ? menuItemHoverBg : undefined
          }
          _hover={{ bg: menuItemHoverBg }}
        >
          {t("common.user.menu.support")}
        </MenuItem>
        <MenuItem
          icon={<FiLogOut />}
          onClick={handleLogout}
          color="red.500"
          _hover={{ bg: menuItemHoverBg }}
        >
          {t("common.user.menu.logout")}
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
